export default __webpack_public_path__ + "fonts/1e930434618f73b6f92aaf116908d0bf.svg";